// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.BellNotification {
  cursor: pointer;
}

.BellNotification.disabled {
  cursor: default;
}

.BellNotification .circle {
  top: -5px;
  right: 0px;
  position: absolute;
  width: var(--default-BellbuttonWidth);
  height: var(--default-BellbuttonHeight);
  border-radius: 10px;
  background-color: #ffc107;
}

.BellNotification .MuiSvgIcon-colorAction {
  color: #1f3c88;
}

.BellNotification .MuiBadge-badge {
  background-color: #ffc107 !important;
  color: #5a5a5a;
}

.BellNotification .count {
  text-align: center;
  overflow: hidden;
  color: #5a5a5a;
  text-overflow: ellipsis;
  white-space: normal;
  font-family: var(--default-FontName);
  font-size: var(--default-BellbuttonFontSize);
  font-weight: var(--default-FontWeight);
}

.notify_divider {
  height: 0.5px !important;
  width: 95% !important;
  margin: auto !important;
}

.notify_menu
  .MuiPaper-root.MuiMenu-paper.MuiPopover-paper.MuiPaper-elevation8.MuiPaper-rounded {
  margin-top: 10px;
  width: 23.69vw;
  /* top: 7.937vh !important; */
  top: 80px !important;
  overflow: hidden;
  /* max-height: 64.567vh; */
  height: auto;
  max-height: 64.567vh;
}

.notify_menuItem {
  text-overflow: ellipsis;
  cursor: auto !important;
}

.notify_menu .MuiList-padding {
  padding-top: 0px;
  padding-bottom: 0px;
}

.notificationContent {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.notificationContentHeading {
  font-family: var(--default-FontName);
  font-style: normal;
  font-weight: var(--header-FontWeight);
  font-size: var(--default-NotificationContentHeadingFontSize);
  line-height: 50px;
  color: #000000;
  margin-left: 4%;
}

.notificationContentData {
  height: 100%;
  overflow-y: auto;
}

.notificationContent {
  display: grid;
  grid-template-columns: 1fr min-content;
  padding: 0px 0px 10px 0px;
}

.readCircleDiv {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.302vw;
  height: 2.66vh;
}

.readCircleDiv .read {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: transparent;
}

.readCircleDiv .unread {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: var(--button-color);
}

.notificationContentText .read {
  font-weight: var(--default-FontWeight);
  font-size: var(--default-FontSize);
  line-height: 21px;
  color: var(--default-NotificationContentReadColor);
}

.notificationContentText .unread {
  max-height: 4.482vh;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: var(--default-FontSize);
  font-weight: var(--sub-header-FontWeight);
  color: var(--default-NotificationContentUnReadColor);
}
.notificationContentfooter {
  display: flex;
  justify-content: space-between;
}
.notificationContentfooter .read {
  font-weight: var(--default-FontWeight);
  font-size: var(--default-FontSize);
  color: var(--default-NotificationContentReadColor);
}

.notificationContentfooter .unread {
  font-weight: var(--sub-header-FontWeight);
  font-size: var(--default-FontSize);
  color: var(--default-NotificationContentUnReadColor);
}

.divMainNotofication .notificationContentDate {
  display: flex;
  align-items: center;
  justify-content: end;
  font-size: var(--default-NotificationDateFontSize);
  color: var(--placeHolderColor);
  font-weight: var(--label-FontWeight);
  line-height: 18.62px;
}

.notify_menu > div:first-of-type {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: black;
}

.viewAllDiv {
  text-align: center;
  padding-top: 30px;
  padding-bottom: 10px;
}

.notify_menu .MuiMenu-list {
  box-sizing: border-box;
  position: relative;
  background: #ffffff;
  border: 1px solid #b6b6b6;
  border-radius: 6px;
  /* height: 100%;
  width: 100%; */
  overflow-y: hidden;
  display: grid;
  grid-template-rows: min-content 1fr;
  height: auto;
  max-height: 64.567vh;
}

.notify_menuItem.Header {
  border-bottom: none;
}

.notify_menuItem.ReadColor {
  background-color: white;
}

.notify_menuItem.UnReadColor {
  background: var(--default-NotificationContentUnReadRowColor);
  border-bottom: 1px solid var(--default-NotificationContentRowBorderColor);
}

.notify_menuItem.newNotifyColor {
  background-color: #d8d7d7;
}

.divMainNotofication .MuiMenuItem-root {
  overflow: hidden;
  font-size: var(--default-FontSize);
  box-sizing: border-box;
  min-height: 48px;
  font-family: var(--default-FontName);
  font-weight: var(--default-FontWeight);
  line-height: 2.5;
  padding-top: 15px;
  white-space: nowrap;
  letter-spacing: 0.00938em;
  padding-bottom: 10px;
  display: list-item;
  /* width: 98%; */
  width: 100%;
  max-height: 11.205vh;
}

.notificationContentText {
  overflow: hidden;
}

.notificationContentText .messageText {
  margin: 0px;
  /* height: 48px; */
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
}

@media (min-width: 491px) and (max-width: 1024px) {
  .notify_menu .MuiMenu-list {
    padding-right: 0px !important;
    width: 100% !important;
  }
}

@media (min-width: 1500px) {
  .notify_menu
    .MuiPaper-root.MuiMenu-paper.MuiPopover-paper.MuiPaper-elevation8.MuiPaper-rounded {
    margin-top: 10px !important;
    top: 0vh;
  }
}

@media (max-width: 1499px) {
  .notify_menu
    .MuiPaper-root.MuiMenu-paper.MuiPopover-paper.MuiPaper-elevation8.MuiPaper-rounded {
    margin-top: 10px !important;
    top: 65px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/components/base/bellNotification/BellNotification.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,qCAAqC;EACrC,uCAAuC;EACvC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;EACpC,4CAA4C;EAC5C,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;EAC1B,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,qCAAqC;EACrC,4DAA4D;EAC5D,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;EAClC,yCAAyC;EACzC,oDAAoD;AACtD;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,sCAAsC;EACtC,kCAAkC;EAClC,kDAAkD;AACpD;;AAEA;EACE,yCAAyC;EACzC,kCAAkC;EAClC,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,kDAAkD;EAClD,8BAA8B;EAC9B,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB;gBACc;EACd,kBAAkB;EAClB,aAAa;EACb,mCAAmC;EACnC,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,4DAA4D;EAC5D,yEAAyE;AAC3E;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;EACtB,gBAAgB;EAChB,oCAAoC;EACpC,sCAAsC;EACtC,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;IACE,6BAA6B;IAC7B,sBAAsB;EACxB;AACF;;AAEA;EACE;;IAEE,2BAA2B;IAC3B,QAAQ;EACV;AACF;;AAEA;EACE;;IAEE,2BAA2B;IAC3B,oBAAoB;EACtB;AACF","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.BellNotification {\n  cursor: pointer;\n}\n\n.BellNotification.disabled {\n  cursor: default;\n}\n\n.BellNotification .circle {\n  top: -5px;\n  right: 0px;\n  position: absolute;\n  width: var(--default-BellbuttonWidth);\n  height: var(--default-BellbuttonHeight);\n  border-radius: 10px;\n  background-color: #ffc107;\n}\n\n.BellNotification .MuiSvgIcon-colorAction {\n  color: #1f3c88;\n}\n\n.BellNotification .MuiBadge-badge {\n  background-color: #ffc107 !important;\n  color: #5a5a5a;\n}\n\n.BellNotification .count {\n  text-align: center;\n  overflow: hidden;\n  color: #5a5a5a;\n  text-overflow: ellipsis;\n  white-space: normal;\n  font-family: var(--default-FontName);\n  font-size: var(--default-BellbuttonFontSize);\n  font-weight: var(--default-FontWeight);\n}\n\n.notify_divider {\n  height: 0.5px !important;\n  width: 95% !important;\n  margin: auto !important;\n}\n\n.notify_menu\n  .MuiPaper-root.MuiMenu-paper.MuiPopover-paper.MuiPaper-elevation8.MuiPaper-rounded {\n  margin-top: 10px;\n  width: 23.69vw;\n  /* top: 7.937vh !important; */\n  top: 80px !important;\n  overflow: hidden;\n  /* max-height: 64.567vh; */\n  height: auto;\n  max-height: 64.567vh;\n}\n\n.notify_menuItem {\n  text-overflow: ellipsis;\n  cursor: auto !important;\n}\n\n.notify_menu .MuiList-padding {\n  padding-top: 0px;\n  padding-bottom: 0px;\n}\n\n.notificationContent {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.notificationContentHeading {\n  font-family: var(--default-FontName);\n  font-style: normal;\n  font-weight: var(--header-FontWeight);\n  font-size: var(--default-NotificationContentHeadingFontSize);\n  line-height: 50px;\n  color: #000000;\n  margin-left: 4%;\n}\n\n.notificationContentData {\n  height: 100%;\n  overflow-y: auto;\n}\n\n.notificationContent {\n  display: grid;\n  grid-template-columns: 1fr min-content;\n  padding: 0px 0px 10px 0px;\n}\n\n.readCircleDiv {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.302vw;\n  height: 2.66vh;\n}\n\n.readCircleDiv .read {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background-color: transparent;\n}\n\n.readCircleDiv .unread {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background-color: var(--button-color);\n}\n\n.notificationContentText .read {\n  font-weight: var(--default-FontWeight);\n  font-size: var(--default-FontSize);\n  line-height: 21px;\n  color: var(--default-NotificationContentReadColor);\n}\n\n.notificationContentText .unread {\n  max-height: 4.482vh;\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: var(--default-FontSize);\n  font-weight: var(--sub-header-FontWeight);\n  color: var(--default-NotificationContentUnReadColor);\n}\n.notificationContentfooter {\n  display: flex;\n  justify-content: space-between;\n}\n.notificationContentfooter .read {\n  font-weight: var(--default-FontWeight);\n  font-size: var(--default-FontSize);\n  color: var(--default-NotificationContentReadColor);\n}\n\n.notificationContentfooter .unread {\n  font-weight: var(--sub-header-FontWeight);\n  font-size: var(--default-FontSize);\n  color: var(--default-NotificationContentUnReadColor);\n}\n\n.divMainNotofication .notificationContentDate {\n  display: flex;\n  align-items: center;\n  justify-content: end;\n  font-size: var(--default-NotificationDateFontSize);\n  color: var(--placeHolderColor);\n  font-weight: var(--label-FontWeight);\n  line-height: 18.62px;\n}\n\n.notify_menu > div:first-of-type {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background-color: black;\n}\n\n.viewAllDiv {\n  text-align: center;\n  padding-top: 30px;\n  padding-bottom: 10px;\n}\n\n.notify_menu .MuiMenu-list {\n  box-sizing: border-box;\n  position: relative;\n  background: #ffffff;\n  border: 1px solid #b6b6b6;\n  border-radius: 6px;\n  /* height: 100%;\n  width: 100%; */\n  overflow-y: hidden;\n  display: grid;\n  grid-template-rows: min-content 1fr;\n  height: auto;\n  max-height: 64.567vh;\n}\n\n.notify_menuItem.Header {\n  border-bottom: none;\n}\n\n.notify_menuItem.ReadColor {\n  background-color: white;\n}\n\n.notify_menuItem.UnReadColor {\n  background: var(--default-NotificationContentUnReadRowColor);\n  border-bottom: 1px solid var(--default-NotificationContentRowBorderColor);\n}\n\n.notify_menuItem.newNotifyColor {\n  background-color: #d8d7d7;\n}\n\n.divMainNotofication .MuiMenuItem-root {\n  overflow: hidden;\n  font-size: var(--default-FontSize);\n  box-sizing: border-box;\n  min-height: 48px;\n  font-family: var(--default-FontName);\n  font-weight: var(--default-FontWeight);\n  line-height: 2.5;\n  padding-top: 15px;\n  white-space: nowrap;\n  letter-spacing: 0.00938em;\n  padding-bottom: 10px;\n  display: list-item;\n  /* width: 98%; */\n  width: 100%;\n  max-height: 11.205vh;\n}\n\n.notificationContentText {\n  overflow: hidden;\n}\n\n.notificationContentText .messageText {\n  margin: 0px;\n  /* height: 48px; */\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 100%;\n}\n\n@media (min-width: 491px) and (max-width: 1024px) {\n  .notify_menu .MuiMenu-list {\n    padding-right: 0px !important;\n    width: 100% !important;\n  }\n}\n\n@media (min-width: 1500px) {\n  .notify_menu\n    .MuiPaper-root.MuiMenu-paper.MuiPopover-paper.MuiPaper-elevation8.MuiPaper-rounded {\n    margin-top: 10px !important;\n    top: 0vh;\n  }\n}\n\n@media (max-width: 1499px) {\n  .notify_menu\n    .MuiPaper-root.MuiMenu-paper.MuiPopover-paper.MuiPaper-elevation8.MuiPaper-rounded {\n    margin-top: 10px !important;\n    top: 65px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
